// extracted by mini-css-extract-plugin
export default {"cls1":"Unibrow-cls1___eab047161ac70eb734d","cls2":"Unibrow-cls2__e1b713bbcfd6092b2eb0 Unibrow-cls1___eab047161ac70eb734d"};